import { render, staticRenderFns } from "./reservations-table.vue?vue&type=template&id=6eb8ef32"
import script from "./reservations-table.vue?vue&type=script&lang=js"
export * from "./reservations-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports